export default __webpack_public_path__ + "static/media/login.8a0672d2.png";